export const column2object = (columns: any[]) => {
  return {
    disabled: columns[2],
    key: columns[3],
    display: columns[4],
    icon: columns[5],
    order: columns[6],
  }
}
